{
  "organizations": {
    "navigation_title": "Organizations",
    "all": "All Organizations",
    "filter_input": "Filter organizations...",
    "partners_filter_input": "Filter partnerships...",
    "invitations_filter_input": "Filter invitations...",
    "formation_requests_filter_input": "Filter organization requests...",
    "title": "Organizations",
    "new": "Create Organization",
    "edit": "Edit Organization",
    "form_title": "Organization",
    "create_new": "Create Organization",
    "rental": "Rental",
    "past_due_warned": "Past Due",
    "save": "Save",
    "go_to_index": "Back To Organizations",
    "select_industry": "Select Industry...",
    "more_info": {
      "contact_info": "Contact",
      "office": "Office",
      "address": "Address"
    },
    "send_formation_request": "Request Organization",
    "edit_details": "Edit Organization",
    "logo": "Logo",
    "requests": "Requests",
    "dialogs": {
      "delete": {
        "title": "Are you sure?",
        "content": "Are you sure you want to delete \"%{name}\" organization? You can't undo this action"
      }
    }
  }
}
